import React from 'react'
import { Menu, MenuItem, SubMenu } from 'react-pro-sidebar'
import classNames from 'classnames'

import {
    faBriefcase,
    faComputer,
    faHome,
    faImage,
    faMoneyBill1,
    faPaperPlane,
    faBullhorn,
    faFile,
    faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { AclService } from '@service/acl'

import logoInternal from '@public_images/logo-sm.png'


class SideBar extends React.Component {
    render() {
        return (

            <Menu id='sidebar' className={classNames('sidebar', { 'toggled': !this.props.isOpen })}>
                <a className='sidebar-brand' href='/'>
                    <img src={ logoInternal } alt='Logo' height={28} /> Saúde Sem Papel
                </a>

                <div className='sidebar-content pb-6'>
                    <div className='sidebar-user'>
                        <div className='fw-bold'>{AclService.getUser().name}</div>
                        <small>{AclService.getUser().position.title}</small>
                    </div>

                    <MenuItem 
                        icon={
                            <FontAwesomeIcon 
                                icon={faHome} 
                                className='align-middle me-2 fas fa-fw'
                            />
                        } 
                        href='/dashboard'
                    >Dashboard</MenuItem>

                    {/* <MenuItem 
                        icon={
                            <FontAwesomeIcon 
                                icon={faBriefcase} 
                                className='align-middle me-2 fas fa-fw'
                            />
                        } 
                        href='/customers'
                    >Gestão de Projetos</MenuItem> */}


                    {/* Aline */}
                    
                    <SubMenu 
                        label='Ouvidoria' 
                        icon={
                            <FontAwesomeIcon 
                                icon={faBullhorn} 
                                className='align-middle me-2 fas fa-fw'
                            />
                        }
                    >
                        <MenuItem href='/ombudsman'>Dashboard</MenuItem>
                        <MenuItem href='/ombudsman/categories'>Categorias</MenuItem>
                        <MenuItem href='/ombudsman/origins'>Origens</MenuItem>
                        <MenuItem href='/ombudsman/types'>Tipo de Manifestação</MenuItem>
                        {/* <MenuItem href='/ombudsman/complainers'>Manifestantes</MenuItem> */}
                        <MenuItem href='/ombudsman/manifestations'>Lista de Ocorrências</MenuItem>
                    </SubMenu>


                    {/* Juliana */}
                    <SubMenu 
                        label='Gerenciamento' 
                        icon={
                            <FontAwesomeIcon 
                                icon={faFile} 
                                className='align-middle me-2 fas fa-fw'
                            />
                        }
                    >
                        <MenuItem href='/management/contracts'>Contratos</MenuItem>
                        {/* <MenuItem href=''>Processos</MenuItem>
                        <MenuItem href=''>Oficios</MenuItem> */}
                    </SubMenu>

                    <MenuItem 
                        className='text-danger'
                        icon={
                            <FontAwesomeIcon 
                                icon={faSignOutAlt} 
                                className='align-middle me-2 fas fa-fw'
                            />
                        }
                        href='/'
                    >Sair</MenuItem>
                </div>
            </Menu>

        )
    }
}

export default SideBar;